import { useQuery } from "react-query";
import Sector from "../apiResources/Sector";

export const useSectors = () => {
  return useQuery(["sectors"], async () => (await Sector.all()).data, {
    refetchOnWindowFocus: false,
  });
};
